import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { Scopes } from '@ninety/platform/models';
import { FeatureFlagKeys } from '@ninety/platform/state/app-entities/feature-flag/feature-flag-state.model';
import { selectFeatureFlag } from '@ninety/platform/state/app-entities/feature-flag/feature-flag-state.selectors';
import { selectIsFeatureReadOnly } from '@ninety/platform/state/app-global/entitlements/entitlements-state.selectors';
import { selectPrimary } from '@ninety/platform/state/app-global/spinner/spinner-state.selectors';
import { ASSESSMENTS_ENABLED_STREAM, MASTERY_READ_ONLY_STREAM, PRIMARY_SPINNER_ACTIVE_STREAM } from '@ninety/ui/core';

/**
 * Binds the tokens consumed by `CustomLanguageComponent` in `@ninety/ui/core` to their platform-backed
 * selectors: the global primary spinner (`selectPrimary`), the assessments feature flag
 * (`selectFeatureFlag(FeatureFlagKeys.enableAssessments)`) and the Mastery read-only entitlement
 * (`selectIsFeatureReadOnly(Scopes.mastery)`). The component stays free of `@ninety/platform/state`,
 * which has no build target and so cannot be compiled into the public package; this composition-root
 * wiring is the single place that depends on both the tokens and those selectors. The selector
 * parameters live here rather than in the component so `FeatureFlagKeys` stays out of it too.
 * (DEV-26530 part 16)
 */
export const CUSTOM_LANGUAGE_PROVIDERS: Provider[] = [
  {
    provide: PRIMARY_SPINNER_ACTIVE_STREAM,
    useFactory: (store: Store) => store.select(selectPrimary),
    deps: [Store],
  },
  {
    provide: ASSESSMENTS_ENABLED_STREAM,
    useFactory: (store: Store) => store.select(selectFeatureFlag(FeatureFlagKeys.enableAssessments)),
    deps: [Store],
  },
  {
    provide: MASTERY_READ_ONLY_STREAM,
    useFactory: (store: Store) => store.select(selectIsFeatureReadOnly(Scopes.mastery)),
    deps: [Store],
  },
];
